import { defineComponent, toRefs, PropType, ref, computed } from '@vue/composition-api';
import {
  AdgroupFormData,
  CampaignFormData,
  FullNormalFormData,
  AcoFormData,
  DeepLinkType,
  ACTION_TYPE,
  NormalCreative
} from '@tt4b/ttam-enums';
import formItemRejectReason from '@/components/common/form-item-reject-reason/index.vue';
import { useCreativeDeepLinkValidate, useDeepLinkFormStatus } from '@tt4b/ttam-hooks';

import CreativeDeepLink from '../index';
import FallbackCompose from '../fallback-compose/index.vue';

const name = 'ttam-creative-deeplink-compose';
export default defineComponent({
  name,
  components: {
    FallbackCompose,
    formItemRejectReason,
    TtamCreativeDeepLinkInput: CreativeDeepLink.TtamCreativeDeepLinkInput,
    TtamCreativeDeepLinkPreviewDialog: CreativeDeepLink.TtamCreativeDeepLinkPreviewDialog,
    TtamCreativeDeepLinkSwitch: CreativeDeepLink.TtamCreativeDeepLinkSwitch,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData & AcoFormData>,
      default: () => ({}),
    },
    // TODO 是否可以放到store
    rejectReason: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    createMode: {
      type: String,
      default: () => ACTION_TYPE.CREATE,
    },
    currentAdgroupIdCreativeList: {
      type: Array as PropType<NormalCreative[]>,
      default: () => [],
    },
    isDisabledCreative: {
      type: Boolean,
      default: () => false,
    },
  },
  setup(props, { emit }) {
    const { adgroupData, campaignData, creativeData, currentAdgroupIdCreativeList, createMode, isDisabledCreative } =
      toRefs(props);

    const _isOpenUrl = computed({
      get: () => creativeData.value.isOpenUrl,
      set: v => {
        emit('is-open-url-change', v);
      },
    });

    const _openUrl = computed({
      get: () => creativeData.value.openUrl,
      set: val => {
        emit('open-url-change', val);
      },
    });

    const onFallbackTypeChange = val => {
      emit('fallback-type-change', val);
    };

    const onFallbackUrlChange = val => {
      emit('fallback-url-change', val);
    };

    const commonProps = {
      adgroupData,
      campaignData,
      creativeData,
    };

    const { deepLinkUrlValidator } = useCreativeDeepLinkValidate({
      campaignFormData: campaignData,
      adgroupFormData: adgroupData,
    });

    const previewDialogVisible = computed(() => creativeData.value.isOpenUrl && !creativeData.value.openUrl);

    const { isSalesShowDeeplinkCustomInput: deepLinkUrlVisible } = useDeepLinkFormStatus({
      adgroupFormData: adgroupData,
      campaignFormData: campaignData,
      creativeFormData: creativeData,
    });

    const { disabled: fallbackDisabled } = CreativeDeepLink.useFallBackPropsDisabled({
      adgroupData,
      campaignData,
      creativeData,
      createMode,
      currentAdgroupIdCreativeList,
      isDisabledCreative,
    });

    return {
      name,
      onFallbackTypeChange,
      onFallbackUrlChange,

      _isOpenUrl,
      _openUrl,

      deepLinkUrlValidator,

      previewDialogVisible,
      deepLinkUrlVisible,

      DeepLinkType,

      fallbackDisabled,
    };
  },
});
